// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"SU-z","inlineTitle":"TU-z","sponsoredAdsWrapper":"UU-z","marketplaceRecosWrapper":"VU-z"};